import React from "react";

const CustomLoader = () => {
  return (
    <div className="mt-16 py-10 w-full h-full">
      <div className="flex flex-wrap justify-center items-center gap-3 h-full">
        <div className="loader"></div>
      </div>
    </div>
  );
};

export default CustomLoader;
